import { apiAxios } from "./axios/api.js";
import { api as healthApi } from "./health/api.js";
import { api as helloApi } from "./hello/api.js";
import {
  api as incidentWorkItemApi,
  apiHooks as incidentWorkItemApiHooks,
} from "./incidentWorkItem/api.js";
import {
  api as locationPrecisionOverrideApi,
  apiHooks as locationPrecisionOverrideApiHooks,
} from "./locationPrecisionOverride/api.js";
import {
  api as notificationApi,
  apiHooks as notificationApiHooks,
} from "./notification/api.js";
import {
  api as organisationApi,
  apiHooks as organisationApiHooks,
} from "./organisation/api.js";
import {
  api as placeOfSafetyApi,
  apiHooks as placeOfSafetyHooks,
} from "./placeOfSafety/api.js";
import { api as reportApi } from "./report/api.js";
import { api as userApi, apiHooks as userApiHooks } from "./user/api.js";
import {
  api as userDirectoryInstanceApi,
  apiHooks as userDirectoryInstanceApiHooks,
} from "./userDirectoryInstance/api.js";

export const apiHooks = {
  ...incidentWorkItemApiHooks(),
  ...locationPrecisionOverrideApiHooks(),
  ...notificationApiHooks(),
  ...organisationApiHooks(),
  ...userApiHooks(),
  ...userDirectoryInstanceApiHooks(),
  ...placeOfSafetyHooks(),
};

export default {
  ...helloApi(apiAxios),
  ...incidentWorkItemApi(apiAxios),
  ...locationPrecisionOverrideApi(apiAxios),
  ...organisationApi(apiAxios),
  ...userApi(apiAxios),
  ...userDirectoryInstanceApi(apiAxios),
  ...placeOfSafetyApi(apiAxios),
  ...notificationApi(apiAxios),
  ...healthApi(apiAxios),
  ...reportApi(apiAxios),
};
